// Hook listy odbiorców klienta handlowca – GET /sales-crm/clients/:cid/receivers

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface ISalesCrmReceiverOption {
  id: number;
  name: string | null;
  name_address: string | null;
  street: string | null;
  house_number: string | null;
  apartment_number: string | null;
  postal_code: string | null;
  city: string | null;
  address_formatted: string | null;
}

export interface ISalesCrmReceiversResponse {
  items: ISalesCrmReceiverOption[];
}

const getSalesCrmClientReceivers = (
  clientId: number
): Promise<ISalesCrmReceiversResponse> =>
  axios.get(`/sales-crm/clients/${clientId}/receivers`);

export const useGetSalesCrmClientReceivers = (
  clientId: number,
  options?: UseQueryOptions<ISalesCrmReceiversResponse, IError>
) =>
  useQuery<ISalesCrmReceiversResponse, IError>(
    ['sales-crm', 'client', clientId, 'receivers'],
    () => getSalesCrmClientReceivers(clientId),
    {
      ...options,
      enabled: options?.enabled !== false && clientId > 0
    }
  );
